import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Empty from 'src/components/Empty'
import LoadingPage from 'src/components/LoadingPage'
import type { Manga } from 'src/services/apollo/generated/graphql'
import { useGetMangaChapter } from 'src/services/apollo/manga'
import MangaViewer from '../Viewer'
import MangaViewerFooter from './Footer'
import MangaViewerNavbar from './Navbar'

const MangaDetail: FC<{
  manga: Manga
  onLikeClick?: () => void
}> = ({ manga, onLikeClick }) => {
  const { t } = useTranslation(['manga'])

  const { data: chapter, loading: isLoadingChapter } = useGetMangaChapter({
    mangaId: manga.id,
    index: 0,
  })

  if (!chapter) {
    if (isLoadingChapter) return <LoadingPage />

    return <Empty description={t('manga:manga-not-found')} />
  }

  return (
    <main>
      <div className="w-full text-white bg-black">
        <MangaViewerNavbar
          showHomeButton={false}
          manga={manga}
          onLikeClick={onLikeClick}
        />
      </div>
      <MangaViewer manga={manga} artwork={manga.artwork} chapter={chapter} />
      <MangaViewerFooter manga={manga} />
    </main>
  )
}

export default MangaDetail
